import { InsuranceState } from "@/core/models/insurance";

export default {
  insurances: (state: InsuranceState) => state.insurances,
  getIsInsuranceExpired: (state: InsuranceState) => state.isInsuranceExpired,
};
